export interface ClipboardFilter {
    filterId: number;
    filterValues: string;
}

export const copyFiltersToClipboard = async (
    filters: ClipboardFilter[],
) => {
    await navigator.clipboard.writeText(
        JSON.stringify({
            type: 'PATH_FILTERS',
            version: 1,
            filters,
        }),
    );
};

export const pasteFiltersFromClipboard =
    async (): Promise<
        ClipboardFilter[]
    > => {
        const text =
            await navigator.clipboard.readText();

    let data: any;
    try {
        data = JSON.parse(text);
    } catch (err) {
        throw new Error('Clipboard content is not valid JSON.');
    }

    if (
        data?.type !== 'PATH_FILTERS'
    ) {
        throw new Error(
            'Clipboard does not contain filters',
        );
    }

    if (!Array.isArray(data.filters)) {
        return [];
    }

    return data.filters || [];
};